import * as RadixTooltip from '@radix-ui/react-tooltip';
import classNames from 'classnames';
import { useState } from 'react';

import { useIsTouchDevice } from './IsTouchContext';
import type { TooltipProps } from './types';

import './tooltip.scss';

export const Tooltip = ({
  children,
  content,
  open,
  defaultOpen,
  onOpenChange,
  delayDuration,
  disableHoverableContent,
  hideArrow,
  side,
  sideOffset,
  align,
  alignOffset,
  variant = 'default',
}: TooltipProps & { variant?: 'default' | 'dark' }) => {
  const withArrow = !hideArrow;

  const [openForTouch, setOpenForTouch] = useState(false);
  const isTouch = useIsTouchDevice();

  return (
    <RadixTooltip.Root
      open={open || openForTouch}
      defaultOpen={defaultOpen}
      onOpenChange={(...args) => {
        onOpenChange?.(...args);
        setOpenForTouch(...args);
      }}
      delayDuration={delayDuration}
      disableHoverableContent={disableHoverableContent}
    >
      <RadixTooltip.Trigger asChild>
        <button className="tooltip-trigger-button" onClick={() => isTouch && setOpenForTouch(true)}>
          {children}
        </button>
      </RadixTooltip.Trigger>

      <RadixTooltip.Portal>
        <RadixTooltip.Content
          className={classNames('tooltip-content', {
            'tooltip-content--dark': variant === 'dark',
          })}
          side={side}
          sideOffset={sideOffset}
          align={align}
          alignOffset={alignOffset}
        >
          {content}
          {withArrow && (
            <RadixTooltip.Arrow
              className={classNames('tooltip-arrow', { 'tooltip-arrow--dark': variant === 'dark' })}
            />
          )}
        </RadixTooltip.Content>
      </RadixTooltip.Portal>
    </RadixTooltip.Root>
  );
};
